import { getMealPreferenceOptions, Meals } from './Meals';
import { Countries, getNationalityOptions } from './Countries';
import { Berths, getBerthPreferenceOptions } from './Berths';
import { getSrCitizenOptions, SrCitizenConcessions } from './SrCitizenConcessions';
import { getReservationTypeOptions, ReservationTypes } from './ReservationType';
import { Genders, getGenderOptionsWithNotSpecified } from './Genders';
import { getReservationChoices, ReservationChoices } from './ReservationChoices';
import { HDFC_SMART_BUY_DNS } from "./Constants";

export const RUPEE_SYMBOL = '₹';

export const SENIOR_CITIZEN_CONCESSION = 'Sr. citizen concession is not available in';

export const ADULT_FARE =', hence full adult fare will be charged.';

export const TATKAL_QUOTA = 'Tatkal Quota';

export const LONG_NAMES = 'Long names are shortened to';

export const CHARACTERS ='16 characters';

export const IRCTC_ACCOUNT_REGISTER_COUNT ='irctc_account_register_count';

export const EDIT_NAME = 'by IRCTC. Edit name if it doesn’t match your ID card.';

export const PLEASE_CARRY = 'Please carry an';

export const AGE_PROOF ='age proof';

export const IN_TRAIN = 'in the train.';

export const YOU_CAN_CLICK = 'You can click';

export const SELECT_A ='and select a';

export const BERTH_PREFERENCE = 'berth preference';

export const SELECTED_CLASS = 'appropriate to the selected class';

export const YOU_SELECTED ='You selected';

export const LADIES_QUOTA = 'Ladies Quota';

export const ON_SCREEN = 'on the last screen. Please';

export const AND_SELECT ='and select';

export const PLEASE_SPECIFY = 'Please specify'

export const ANOTHER_TRAVELLER = 'or select another traveller.';

export const ADD_TRAVELLER_MESSAGE = 'Add Traveller Information';

export const AVAILABILITY_UPDATED_MESSAGE = 'moments ago';

export const INFANT_AGE_PROOF_MESSAGE = 'Names of children below 5 yrs will not appear in the ticket as they can travel free of charge (without berth).Please carry an age proof in train';

export const INFANT_INFO_MESSAGE = "Children under 5 yrs of age can travel free of charge (without berth)";

export const TRAVELLER_ERROR_MESSAGE = 'Please resolve errors to proceed further';

export const TNC_ERROR_MESSAGE = 'Please accept the cancellation and refund policy';

export const NAME_DEFAULT='';

export const AGE_DEFAULT = '';

export const GSTIN_USER_CONSENT = 'Please provide user consent';

export const GSTIN_STATE_ENTER = 'Please enter state';

export const TRAIN_NOT_OPEN_FOR_BOOKING = 'Train not open for booking'

export const TRAIN_OUTSIDE_RESERVATION_WINDOW = "This action not allowed as the Date given is Outside Advance Reservation Period- (80012)\n";

export const ADDITIONAL_PREFERENCES_TITLE = "Additional Preferences";

export const OPTIONAL_TEXT = "Optional";

export const INSURANCE_TITLE = "IRCTC Travel Insurance";

export const INSURANCE_MESSAGE = "Would you like to take Travel Insurance for ₹ ";

export const PER_PERSON ="per person?";

export const SELECT_INSURANCE_CHOICE = "Please select travel insurance choice";

export const INSURANCE_YES_TEXT = "Yes, and I accept the ";

export const INSURANCE_TERMS_AND_CONDITIONS ="Insurance Terms & Conditions";

export const INSURANCE_NO_TEXT = "No, I don’t want travel insurance";

export const VIEW_MORE ="View More";

export const VIEW_ALL ="View All";

export const CONFIRM_BOOK_WARNING = "Book only if confirm berths are allotted.";

export const CONFIRM_BOOK_FAILURE_WARNING = "Your booking will fail if confirmed berths are not available";

export const AUTO_UPGRADE_OPTION = "Consider for auto-upgradation (optional)";

export const GENDER_DEFAULT = getGenderOptionsWithNotSpecified()
  .find((gender) => Genders.NOT_SPECIFIED.key === gender.id);

export const MEAL_PREFERENCE_DEFAULT = getMealPreferenceOptions()
  .find((meal) => Meals.VEG.key === meal.id);

export const COUNTRY_PREFERENCE_DEFAULT = getNationalityOptions()
  .find((country) => Countries.IN.code === country.id);

export const BERTH_PREFERENCE_DEFAULT = getBerthPreferenceOptions()
  .find((berth) => Berths.NO_BERTH.key === berth.id);

export const SENIOR_CITIZEN_CONCESSION_DEFAULT = getSrCitizenOptions()
  .find((srCitConcession) => `${SrCitizenConcessions.FULL_CONCESSION.key}` === srCitConcession.id);

export const RESERVATION_TYPE_DEFAULT = getReservationTypeOptions()
  .find((reservationType) => ReservationTypes.FULL_TICKET.key === reservationType.id);

export const RESERVATION_CHOICE_DEFAULT = (lb) => getReservationChoices(lb)
  .find((reservationChoice) => ReservationChoices.None.value === reservationChoice.id);

export const LOGGED_IN_TRAVELLERS = 'LOGGED_IN_TRAVELLERS';

export const GUEST_TRAVELLERS = 'GUEST_TRAVELLERS';

export const isHdfcSmartBuyUrl = () =>
  typeof window !== "undefined" &&
  window.location.href.toLowerCase().includes(HDFC_SMART_BUY_DNS);

export const MMT_AUTH = !isHdfcSmartBuyUrl() ? "mmt-auth" : "mmt-auth-hdfc_sb";

export const MYBIZ_BLOCKED_LOB_ID = 'TRAIN';

export const BIZ_PROFILE = 'b2b';

export const MY_BUSINESS_SUBSCRIPTION = 'myBusinessSubscription';

export const CANCELLATION_AND_REFUND_PAGE = 'https://rails.makemytrip.com/pwa/mobile/refundRules/';

export const GET_CAPTCHA = 'https://railways.makemytrip.com/trains/users/getCaptcha';

export const USER_AGREEMENT = 'https://www.makemytrip.com/legal/user_agreement.html';

export const TERMS_OF_SERVICE = 'https://www.makemytrip.com/legal/user_agreement.html#tos-train';

export const INSURANCE_TERMS_AND_CONDITIONS_PAGE = 'https://rails.makemytrip.com/pwa/mobile/trainsInsuranceTnC/';

export const GET_IRCTC_BOOKING_ID_URL = 'https://rails.makemytrip.com/pwa/mobile/booking/getBookingId/v2';

export const PRIVACY_POLICY = 'https://www.makemytrip.com/legal/privacy_policy.html';

export const TrainTypes = Object.freeze({
  SV: {
    value: 'Suvidha Trains',
    key: 'SV',
  },
  ST: {
    value: 'Special Tatkal Trains',
    key: 'ST',
  },
  SP: {
    value: 'Special Trains',
    key: 'SP',
  },
  G: {
    value: 'Garib Rath',
    key: 'G',
  },
  Y: {
    value: 'Yuva Express',
    key: 'Y',
  },
  O: {
    value: 'Others',
    key: 'O',
  },
  D: {
    value: 'Duronto',
    key: 'D',
  },
  R: {
    value: 'Rajdhani',
    key: 'R',
  },
  JS: {
    value: 'Jan Shatabdi',
    key: 'JS',
  },
  S: {
    value: 'Shatabdi',
    key: 'S',
  },
});

export const getTrainType = (key) => {
  return TrainTypes[key] ? TrainTypes[key].value : key;
};

export const SuperFastTrains = {
  R: true, JS: true, S: true, D: true,
};

export const RAILS_CURR_AVL = "CURR_AVL";

export const RAILS_SESSION_ID_EXPIRY_IN_MINUTES = 40;
export const RAILS_SESSION_ID_KEY = 'session-id';
export const APP_LANGUAGE = "eng";
export const CUSTOMER_PROFILE = "personal"
export const CUSTOMER_REGION = "in";
export const RAILS_LOB = "rails";
export const RECENT_SEARCH_RAILS_COLUMN = "train";
export const COUNTRY = {
  CODE: "IN",
  NAME: "India",
  TIMEZONE: "IST",
};
export const ONWARD_JOURNEY = "OW";
export const TRAIN_CANCELLED = "TRAIN CANCELLED"
export const TRAIN_DEPARTED = "TRAIN DEPARTED"
export const MORE_THAN_ONE_DAY_KEY = "moreThanOneDay";

export const ROUTES_MODAL_TYPE = 'routeModal';
export const DIFFERENT_STATION_MODAL_TYPE = 'differentStationModal';
export const CONFIRMED_OPTIONS_DIFF_STATIONS_MODAL_TYPE = 'confirmedOptionsDifferentStationModal';
export const CONFIRMED_OPTIONS_CONST = 'Confirmed Options';
export const BOOK_FROM_CONST = 'Book from';
export const BOOK_UPTO_CONST = 'Book upto';
export const BOARD_AT_CONST = 'Board at';
export const GET_DOWN_AT_CONST = 'Get down at';
export const BOOK_NOW_CONST = 'Book Now';
export const DESC_CONST = "des";
export const SRC_CONST = "src";
export const BOTH_CONST = "both";
export const CONFIRMED_OPTIONS_DISCLAIMER_PART_1 = "Your ticket will be booked on a longer route. Board at ";
export const CONFIRMED_OPTIONS_DISCLAIMER_PART_2 = " and get down at ";
export const AddAtErrorPageUuid = 'UkFJTCNUUkFJTlMgREVBREVORCBTUlAgI1RPUCBGT0xE';
export const AYODHYA_CHECK_CONSTANT = "AY";
export const FREE_CANCELLATION_KEY = "fcOpted";
export const FREE_CANCELLATION_STRIP = {
 headerSelected: "Great! Free Cancellation added on all tickets",
 headerNotSelected: "Get Full ticket fare refund if you cancel your train ticket",
 subHeaderSelected: "Assured refund. No questions asked!",
 subHeaderNotSelected: "Assured refund. Trusted by 1lakh+ users",
 widgetHeader: "Opt in to to get full ticket fare refund on cancelling your train ticket",
}
export const FC_TG_WIDGET = {
  tgHeader: "Alternate Travel Plan",
  fcHeader: "Free Cancellation",
  fcSubHeader: "Pay zero railway cancellation charges when ticket is cancelled.",
  fcValidity: "Free cancellation valid till chart preparation.",
  knowMore: "Know more",
  approxRefund: "Refund when you cancel your ticket:",
  added: "added",
  addFc: "Add Free Cancellation for",
  tgSubHeader: "Get 3x refund if this ticket remains waitlisted",
  tgUsage: "Use this voucher to book flight, cab, bus or train.",
  tgTnc: " Waitlisted bookings are eligible for refund. RAC is valid for travel.",
  addTg: "Add Alternate Travel Plan for",
  tgOptOut: "I don’t want to guarantee my trip",
  fcOptOut: "I don’t want Free Cancellation",
  fcDiscountOptOut: "Continue Without Free Cancellation",
  buyTg: "Buy Alternate Travel Plan for",
  buyFc: "Add Free Cancellation for",
  buyFcDiscount: "Buy Free Cancellation @",
  fcToast: "Free Cancellation added to your ticket. You can add only one out of Alternate Travel Plan and Free Cancellation.",
  fcToastV2: "Free Cancellation added to your ticket.",
  tgToast: "Alternate Travel Plan added to your ticket. You can add only one out of Alternate Travel Plan and Free Cancellation.",
  tgToastV2: "Alternate Travel Plan added to your ticket",
  errorMsg: "Do you wish to add Free Cancellation or Alternate Travel Plan to your trip?",
}
export const FC_HEADER = 'Get full ticket fare refund on Cancellation';
export const REFUND = 'Refund';
export const APPROX_REFUND = 'Approx refund';
// ***** Storage Constants ***** //
export const STORAGE_CONSTANTS = {
  VERIFIED_USER_ID: 'verifiedUserId',
  NAME: 'name',
  EMAIL: 'email',
  MOBILE_NUMBER: 'mobileNumber',
}

export const FUNNEL_OMNITURE_KEY = "funnelOmnitures";
export const LISTING_TRACKING_KEY = "funnel:rails:listing";
export const TRAVELLERS_TRACKING_KEY = "funnel:rails:travellers";
export const FC_TG_TOGETHER_KEY = "fctgdweb";
export const FC_ONLY_KEY = "fconlydweb";
export const FC_LISTING_WIDGET_TRACKING_KEY = "fclistingleft";
export const GET_NEW_PASSWORD_RAILS_TRAVELER_TRACKING = "rail_travellers_get_new_pwd";
export const GET_NEW_PASSWORD_RAILS_EDU_MODAL_TRACKING ="rail_travellers_irctc_edu_get_new_pwd";
export const FC_LISTING_STRIP_TRACKING_KEY = "fclistingstrip";
export const IRCTC_EDUCATION_TRACKING_KEY = Object.freeze(["une_0", "une_1"]);
export const WHY_IS_THIS_REQUIRED_TRACKING_KEY = Object.freeze(["wtr_0","wtr_1"]);
export const FC_OPTED_TRACKING_KEY = "fcopt";
export const TG_OPTED_TRACKING_KEY = "tgopt";
export const FC_TG_TRACKING_IDENTIFIER = "opt";
export const LOGGED_OUT_COUPONS_NOT_SHOWN_FIRST = "lg_0";
export const LOGGED_OUT_COUPONS_NOT_SHOWN_SECOND = "lg_1";
export const LOGGED_OUT_COUPONS_SHOWN = "lg_2";
export const LOGIN_TO_AVAIL = "lg_c";
export const LOGIN_TO_AVAIL_CLICKED = "mob_rail_travellers_coupon_login";
export const COUPON_NOT_SHOWN_POKUS_ZERO = 0;
export const COUPON_NOT_SHOWN_POKUS_ONE = 1;
export const COUPON_SHOWN_POKUS = 2;
export const AADHAR_MODAL_FIRED = 'ad_m';

export const MY_BIZ_TRAVELERS = "railsMyBizTravelers";

export const PAGES = {
  LISTING: 'LISTING',
  TRAVELLER: 'TRAVELLER',
}

export const SINGLE_SELECT = "SINGLE_SELECT";
export const MULTI_SELECT = "MULTI_SELECT";

export const TRIP_GUARANTEE = "Alternate Travel Plan";
export const FREE_CANCELLATION = "FREE CANCELLATION";

export const LOGGED_IN_AVAIL = "loginToAvail";
export const LOG_IN_TO_AVAIL_TEXT = "Login to avail";

export const IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR="IRCTC_TATKAL_AADHAAR_NOT_VERIFIED_ERROR";
export const AADHAR_LINK = 'https://www.makemytrip.com/promos/aadhaar-link-tatkal-bookings.html';

export const AADHAR_ERRORS = "dweb_rail_traveller_aadhar_errors"

export const ERROR_MODAL_LOAD = "p_wm";
export const ERROR_MODAL_RESET_PASSWORD_CLICKED = "rail_traveller_get_pwd_clicked";
export const ERROR_MODAL_PASSWORD_RECEIVED_CLICKED = "rail_traveller_pwd_received";
export const ERROR_MODAL_BACK_CLICKED = "rail_traveller_get_pwd_back";
export const ERROR_MODAL_CLOSE_CLICKED = "rail_traveller_get_pwd_close";
export const ERROR_MODAL_CROSS_CLICKED = "rail_traveller_get_pwd_cross";
export const DEFAULT_NEW_PASSWORD_OPTION = "M";

export const NEW_PASSWORD_OPTIONS = [
  {
    label: "On Mobile number",
    name: "newPasswordOn",
    id: "passwordOnMobile",
    value: "M",
    isDefault: true,
  },
  {
    label: "On Email ID",
    name: "newPasswordOn",
    id: "passwordOnEmail",
    value: "E",
    isDefault: false,
  }
];

export const PASSWORD_RESET_LABELS = {
  MOBILE_LABEL: "Password will be sent on registered no. with IRCTC",
  EMAIL_LABEL: "Password will be sent on registered email with IRCTC",
  MOBILE_PLACEHOLDER: "Enter Mobile Number",
  EMAIL_PLACEHOLDER: "Enter your email id",
  MOBILE_VALIDATION_ERROR: "Please enter a valid mobile number",
  EMAIL_VALIDATION_ERROR: "Please enter a valid email address",
  GENERIC_ERROR: "Something went wrong. Please try again."
};

export const INPUT_TYPES = {
  MOBILE: "M",
  EMAIL: "E",
  TEL: "tel",
  EMAIL_TYPE: "email"
};

export const MODAL_CONSTANTS = {
  ERROR_CODE: "RAILS_BOOKING_REVIEW_PASSWORD_EXPIRED",
  TIMEOUT_DURATION: 1500,
  SUCCESS_TIMEOUT: 1000
};

export const CTA_ACTIONS = {
  CLOSE_BOTTOMSHEET: "CLOSE_BOTTOMSHEET",
  GO_BACK: "GO_BACK",
  CALL_API: "CALL_API"
};

export const SOURCE_TYPES = {
  MOBILE: "mobile",
  EMAIL: "email"
};

export const VALIDATION = {
  VALID_MOBILE: "validMobile",
  VALIDATION_ERROR: "validationError"
};

export const INPUT_LIMITS = {
  MOBILE_MAX_LENGTH: 10,
  EMAIL_MAX_LENGTH: 50,
};

export const FUNNEL_SOURCE = {
  STORAGE_KEY: 'funnelSourceData',
  SEO_PARAM: 'isSeo',
  SEM_PARAM: 'cmp',
  DIRECT: 'direct',
  SEO: 'SEO',
  SEM: 'SEM'
};